import * as o from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/PushPin.es.js";
const e = o.forwardRef((r, s) => /* @__PURE__ */ o.createElement(t, { ref: s, ...r, weights: n }));
e.displayName = "PushPinIcon";
const m = e;
export {
  m as PushPin,
  e as PushPinIcon
};
